import { render, staticRenderFns } from "./BotonFlotanteComponent.vue?vue&type=template&id=4c92147a&scoped=true"
import script from "./BotonFlotanteComponent.vue?vue&type=script&lang=js"
export * from "./BotonFlotanteComponent.vue?vue&type=script&lang=js"
import style0 from "./BotonFlotanteComponent.vue?vue&type=style&index=0&id=4c92147a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c92147a",
  null
  
)

export default component.exports